import _map from 'lodash/map';
import _flatten from 'lodash/flatten';

export function mapStyles(array, callback) {
  return _flatten(_map(array, (el) => callback(el))).join('');
}
